import React from "react";
import { DocumentTitle } from "../../components/DocumentTitle/DocumentTitle";
import { Route, Switch } from "react-router-dom/cjs/react-router-dom";
import CMLDetailsContainer from "./CMLDetailsContainer";


export const CMLMain = function ({ match }) {
    return (
        <div className="column">
            <DocumentTitle title={"CARMA - CMLs"} />
            <div>
                <Switch>
                    <Route path={`${match.path}/:id/details`} component={CMLDetailsContainer} />
                </Switch>
            </div>
        </div>
    );
};
